import { map, Observable } from 'rxjs';

import { BookingFacade, BookingStatus, IStateEvent, Option, Transition } from '@contact/upgrade';

const MODULE_NAME = 'contactStatusDeprecatedService';

/**
 * @deprecated prefer BookingFacade
 */
export interface IContactStatusDeprecatedService {
  /**
   * @deprecated prefer BookingFacade.transitionCreated$
   */
  created(): Observable<IStateEvent<BookingStatus>>;

  /**
   * @deprecated prefer BookingFacade.transitionSuccess$
   */
  success(): Observable<IStateEvent<BookingStatus>>;

  /**
   * @deprecated prefer BookingFacade.transitionFailure$
   */
  failure(): Observable<IStateEvent<BookingStatus>>;

  /**
   * @deprecated prefer BookingFacade.getTransitionById
   */
  getContactState(responseId: string): BookingStatus;
}

/**
 * @deprecated prefer BookingFacade
 */
export class ContactStatusDeprecatedService implements IContactStatusDeprecatedService {
  static $inject: Array<string> = ['contactFacade'];

  public name = MODULE_NAME;
  private transitions: Transition[];

  constructor(private readonly contactFacade: BookingFacade) {
    this.contactFacade.transitions$.subscribe(transitions => (this.transitions = transitions));
  }

  /**
   * @deprecated prefer BookingFacade.transitionCreated$
   */
  created() {
    return this.contactFacade.created$.pipe(map(transition => this.toEvent(transition)));
  }

  /**
   * @deprecated prefer BookingFacade.transitionSuccess$
   */
  success() {
    return this.contactFacade.success$.pipe(map(transition => this.toEvent(transition)));
  }

  /**
   * @deprecated prefer BookingFacade.transitionFailure$
   */
  failure() {
    return this.contactFacade.failure$.pipe(
      map(transition => ({
        ...transition,
        current: transition.error!,
      })),
      map(transition => this.toEvent(transition))
    );
  }

  /**
   * @deprecated prefer BookingFacade.getTransitionById
   */
  getContactState(responseId: string): BookingStatus {
    return Option.of(this.transitions.find(transition => transition.id === responseId))
      .map(transition => BookingStatus[transition.current])
      .getOrElse(undefined);
  }

  private toEvent({ id, date, previous, current }: Transition): IStateEvent<BookingStatus> {
    return {
      id,
      timestamp: new Date(date),
      oldState: previous && BookingStatus[previous],
      newState: current && BookingStatus[current],
    };
  }
}

export default MODULE_NAME;
